export class MilitaryDetail {
  sSelfDeclaredMilitaryServiceFlag: boolean;
  sReserveNationalGuardNeverActivatedFlag: boolean;
  sActiveDuty: boolean;
  sServiceExpectedCompletionDate: Date;
  sSeparatedFlag: boolean;
  sSpousalVABenefitsEligibilityFlag: boolean;
}
